import React from 'react';
import isNil from 'lodash/isNil';
import PercentInput from 'components/PercentInput';
import { round } from 'utils/number';
import { getInheritedValue } from 'utils/rateSettings/SharedRateSettingsForm.utils';

type Props = {
  source: string;
  inheritedSettings?: any;
};

// Admin-editable. Labeled "multiplier" because it modifies the pro pay rate,
// but the stored field stays blended_rate_markup. The rate controller watches
// it and refreshes the read-only 12hr Charge Rate.
// format/parse override PercentInput's defaults so an unset value renders
// blank (not "0") and clearing the field stores null (not NaN) — null falls
// back to the inherited value, while an explicit 0 is a real value.
export const BlendedRateMarkupInput = ({ source, inheritedSettings = {} }: Props) => {
  // Subtext mirrors the input's percent display (0.2 stored → "20").
  const inherited = getInheritedValue(inheritedSettings, 'blended_rates.blended_rate_markup');
  const helperText = isNil(inherited) ? '' : String(round(Number(inherited) * 100));

  return (
    <PercentInput
      source={`${source}.blended_rates.blended_rate_markup`}
      label="Blended Rate Multiplier"
      format={(v) => (isNil(v) || v === '' ? '' : round(v * 100))}
      parse={(v) => {
        const parsed = parseFloat(v);
        return Number.isNaN(parsed) ? null : round(parsed / 100);
      }}
      helperText={helperText}
    />
  );
};
